import React from 'react';
import MetricSection from './MetricSection';
import SourceFooter from './SourceFooter';
import TimeSeriesChart from './TimeSeriesChart';
import { ChartPanel, DataTable, datasetById, MetricCallout } from './SectionElements';

const CostEfficiencySection = ({ datasets, range, isZh = false }) => {
    const aider = datasetById(datasets, 'aider_cost_per_success');
    const prices = datasetById(datasets, 'provider_token_prices');
    const state = datasetById(datasets, 'statebench_cost_per_success');
    const latest = aider.series[aider.series.length - 1];

    return (
        <MetricSection
            id="cost-efficiency"
            index={2}
            title="Cost and Efficiency"
            titleZh="成本与效率"
            summary="The core unit is the dollars spent to complete a task successfully—not a vague token-cost proxy."
            summaryZh="核心单位是“成功完成一个任务花多少钱”，Token 单价只作为解释成本结构的辅助指标。"
            isZh={isZh}
        >
            <div className="ai-dev-callout-row ai-dev-callout-row--compact">
                <MetricCallout value={`$${latest.value.toFixed(2)}`} label={isZh ? '每个成功编码任务' : 'per successful coding task'} note={`${latest.model} · ${latest.passRate}% pass`} />
                <MetricCallout value={`$${latest.benchmarkTotalCost.toFixed(2)}`} label={isZh ? '完整基准总成本' : 'full benchmark cost'} note="225 exercises" />
                <MetricCallout value={`${latest.passRate.toFixed(0)}%`} label={isZh ? '性能前沿通过率' : 'frontier pass rate'} note={latest.date} />
            </div>
            <div className="ai-dev-grid ai-dev-grid--cost">
                <ChartPanel eyebrow={isZh ? '单位智能成本' : 'UNIT INTELLIGENCE COST'} title={isZh ? 'Aider 每个成功任务成本' : 'Aider cost per successful task'} note={isZh ? '性能前沿模型；美元/成功任务' : 'performance-frontier models'}>
                    <TimeSeriesChart dataset={aider} range={range} ariaLabel="Aider cost per successful task" scale="log" valueFormatter={(value) => `$${value.toFixed(value < 1 ? 2 : 1)}`} />
                    <SourceFooter dataset={aider} isZh={isZh} />
                </ChartPanel>
                <ChartPanel eyebrow={isZh ? '价格结构' : 'PRICE STRUCTURE'} title={isZh ? '当前前沿 API 标价' : 'Current frontier API list prices'} note="USD / 1M tokens">
                    <DataTable
                        caption={isZh ? '模型输入与输出 Token 标价' : 'Model input and output token list prices'}
                        columns={[
                            { key: 'model', label: isZh ? '模型' : 'Model' },
                            { key: 'input', label: isZh ? '输入' : 'Input', render: (row) => `$${row.inputPerMillion}` },
                            { key: 'output', label: isZh ? '输出' : 'Output', render: (row) => `$${row.outputPerMillion}` },
                        ]}
                        rows={prices.series}
                    />
                    <SourceFooter dataset={prices} isZh={isZh} />
                </ChartPanel>
            </div>
            <SourceFooter dataset={state} isZh={isZh} />
        </MetricSection>
    );
};

export default CostEfficiencySection;
